export default __webpack_public_path__ + "static/card-img03-1076408ebda59732a4f3bf87cab37f9b.jpg";